import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoIg: CultureInfo = {
  name: 'ig',
  displayName: 'Igbo',
  iso3LanguageCode: 'ibo',
  iso2LanguageCode: 'ig',
  ietfLanguageTag: 'ig',
  parent: null
};
